import { put, select, takeEvery } from 'typed-redux-saga';
import { createNotification, NotificationType } from '@integration-frontends/common/notifications';
import {
  callWithTokenRefresh,
  hubspotFetchFolders,
  hubspotReceiveFolders,
  selectSelectedClientId,
} from '@integration-frontends/workflow-manager/core/application';
import {
  FORM_INFO_REPO_TOKEN,
  IFormInfoRepo,
} from '@integration-frontends/workflow-manager/core/model';
import { DI_CONTAINER } from '@integration-frontends/core';
import { pageLoadError } from '@integration-frontends/common/app';
import {
  hubspotFetchInit,
  hubspotFetchLoaded,
} from '@integration-frontends/workflow-manager/core/application';

function* handler(action: ReturnType<typeof hubspotFetchFolders>) {
  yield put(hubspotFetchInit());
  try {
    const { credential_id, sync_folder_id, page } = action.payload;
    const formInfoRepo: IFormInfoRepo = DI_CONTAINER.get(FORM_INFO_REPO_TOKEN);
    const clientId = yield select(selectSelectedClientId);
    const pageParam = page ? page : 1;
    const FOLDERS_PER_PAGE = 20;

    const folders = yield callWithTokenRefresh(formInfoRepo.getHubspotFormInfo, clientId, {
      credential_id,
      folder_id: sync_folder_id,
      per: FOLDERS_PER_PAGE,
      page: pageParam,
    });

    if (folders) {
      yield put(hubspotReceiveFolders({ folders: folders }));
      yield put(hubspotFetchLoaded());
    } else {
      yield put(
        createNotification({
          message: 'Failed to fetch HubSpot Folders',
          location: 'topLevel',
          type: NotificationType.Error,
        }),
      );
    }
  } catch (e) {
    yield put(pageLoadError({ error: e }));
    yield put(hubspotFetchLoaded());
  }
}

export function* hubspotFetchFoldersEffects() {
  yield takeEvery(hubspotFetchFolders, handler);
}
